/**
 * StatisticsHeader Component
 * 
 * Displays overall achievement statistics and per-game breakdown.
 * Includes refresh/sync functionality with loading state.
 * 
 */

import React from 'react';

import SyncButton from '../../../../components/SyncButton';

import { AchievementStatsResponse } from '../../../../types/achievements';

import styles from './StatisticsHeader.module.scss';

/**
 * Props for StatisticsHeader component
 * 
 */
export interface StatisticsHeaderProps {
  stats: AchievementStatsResponse;
  onSync: () => void;
  syncing: boolean;
  isMe: boolean;
}

/**
 * StatisticsHeader Component
 * 
 */
export const StatisticsHeader: React.FC<StatisticsHeaderProps> = ({
  stats,
  onSync,
  syncing,
  isMe,
}) => {
  /**
   * Format percentage for display
   */
  const formatPercentage = (percentage: number): string => {
    return `${Math.round(percentage)}%`;
  };

  return (
    <div className={styles.statisticsHeader}>
      {/* Overall Statistics Section */}
      <section className={styles.overallStats} aria-labelledby="overall-stats-heading">
        <h2 id="overall-stats-heading" className={styles.sectionTitle}>
          Achievement Progress
        </h2>
        
        <div className={styles.statsGrid}>
          <div className={styles.statCard}>
            <div className={styles.statValue}>{stats.totalAchievements}</div>
            <div className={styles.statLabel}>Total Achievements</div>
          </div>
          
          <div className={styles.statCard}>
            <div className={styles.statValue}>{stats.unlockedCount}</div>
            <div className={styles.statLabel}>Unlocked</div>
          </div>
          
          <div className={styles.statCard}>
            <div className={styles.statValue}>
              {formatPercentage(stats.unlockPercentage)}
            </div>
            <div className={styles.statLabel}>Completion</div>
          </div>
        </div>

        {/* Sync Button - Only visible when viewing own profile and not actively syncing */}
        {isMe && !syncing && (
          <SyncButton
            loading={false}
            onClick={onSync}
            text="Refresh"
            ariaLabel="Refresh achievement data"
          />
        )}
      </section>
    </div>
  );
};
